import { ExternalDeliveryProvider, ExternalDeliveryProviders } from 'src/constants/ExternalDeliveryProviders';

export function isUberDaasExternalDeliveryProvider(deliveryProvider?: ExternalDeliveryProvider): boolean {
    return deliveryProvider === ExternalDeliveryProviders.UBER_DAAS || deliveryProvider === ExternalDeliveryProviders.UBER_DIRECT;
}
